import { NavBar } from "@/components/site/NavBar";
import { Hero } from "@/components/site/Hero";
import { AboutGroup } from "@/components/site/AboutGroup";
import { Businesses } from "@/components/site/Businesses";
import { OperatingModel } from "@/components/site/OperatingModel";
import { BrandStatement } from "@/components/site/BrandStatement";
import { GlobalPerspective } from "@/components/site/GlobalPerspective";
import { FinalCta } from "@/components/site/FinalCta";
import { ContactSection } from "@/components/site/ContactSection";
import { SiteFooter } from "@/components/site/SiteFooter";

export default function Home() {
  return (
    <div className="min-h-screen bg-navy-950" data-testid="home-page">
      <NavBar />
      <main>
        <Hero />
        <AboutGroup />
        <Businesses />
        <OperatingModel />
        <BrandStatement />
        <GlobalPerspective />
        <FinalCta />
        <ContactSection />
      </main>
      <SiteFooter />
    </div>
  );
}
